export const useMessageHandlerActions = _ref => {
  let {
    connection,
    connectionId
  } = _ref;
  const addMessageListener = (messageType, handler, options) => {
    connection === null || connection === void 0 || connection.on(messageType, data => {
      var _data$ConnectionId;
      const shouldHandleOwnMessage = !!(options !== null && options !== void 0 && options.shouldHandleOwnMessage);
      const shouldHandleForeignMessage = isConnectionDifferentOrMissing(connectionId !== null && connectionId !== void 0 ? connectionId : undefined, (_data$ConnectionId = data.ConnectionId) !== null && _data$ConnectionId !== void 0 ? _data$ConnectionId : data.connectionId);
      if (shouldHandleOwnMessage || shouldHandleForeignMessage) {
        handler(data);
      }
    });
  };
  const removeMessageListener = messageType => {
    connection === null || connection === void 0 || connection.off(messageType);
  };
  const renewMessageListener = (messageType, handler, options) => {
    removeMessageListener(messageType);
    addMessageListener(messageType, handler, options);
  };
  return {
    addMessageListener,
    removeMessageListener,
    renewMessageListener
  };
};
const isConnectionDifferentOrMissing = (connectionId, messageConnectionId) => {
  return !messageConnectionId || messageConnectionId !== connectionId;
};